module.exports = __webpack_public_path__ + "static/media/ung.a9fb39ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/ung.jpg
// module id = 210
// module chunks = 0